import { render, staticRenderFns } from "./RatingAdminRootView.vue?vue&type=template&id=33432fa6"
import script from "./RatingAdminRootView.vue?vue&type=script&lang=js"
export * from "./RatingAdminRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports